// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","footercontainer":"Footer_footercontainer__HHyqB","icons":"Footer_icons__QDrf7","icon":"Footer_icon__Zscac"};